import { PhilosophyValue } from 'model';
import { ManPage } from 'components/ManPage/ManPage';

export function EngineeringPhilosophy({
  values,
  quotes
}: { values: PhilosophyValue[]; quotes: string[] }): JSX.Element {
  return (
    <ManPage
      name="philosophy"
      section="7"
      manual="Engineering Values"
      sections={[
        {
          heading: 'NAME',
          body: 'philosophy - engineering values'
        },
        {
          heading: 'NOTE',
          body: 'Each value should be considered in its context; apply your judgment -- you are a human, not a machine.'
        },
        {
          heading: 'VALUES',
          body: (
            <>
              {values.map((v, i) => (
                <div key={i}>
                  <div className="man-sub">{v.value}</div>
                  {v.sub.map((s, j) => (
                    <div key={j}>{`- ${s}`}</div>
                  ))}
                  {'\n'}
                </div>
              ))}
            </>
          )
        },
        {
          heading: 'QUOTES',
          body: (
            <>
              {quotes.map((q, i) => (
                <div key={i}>{`- ${q}`}</div>
              ))}
            </>
          )
        }
      ]}
    />
  );
}
